<!--
商详背后的分享图
-->
<template>
  <div v-if="isInApp()">
    <div class="mask" v-if="!isBase64HaveLoaded"></div>
    <div id="canvas" v-if="!isBase64HaveLoaded">
      <section class="share-conatiner">
        <div class="content">
          <div class="title" v-if="!info.isGroupon">
            <img class="avatar" :src="ownerAvatar" alt="" />
            <div class="tips">
              <div class="top">
                by
                <span class="name">{{ ownerName ? ownerName : '孩子王' }}</span>
                的分享
              </div>
              <div class="bottom">
                推荐{{
                  info.shareComponentType == '秒杀' ? '限时秒杀' : '优质'
                }}商品给您，请查收！
              </div>
            </div>
          </div>

          <img class="item-img" :src="$$viewImage(info.productImage)" alt="" />

          <div class="product-title">
            <span class="coupon" v-if="info.shareComponentType == '秒杀'">{{
              info.shareComponentType
            }}</span>
            <span v-for="(item, index) in productTitleChars" :key="index">{{
              item
            }}</span>
          </div>

          <div class="product-price">
            <span class="icon">
              <span class="price-tips">{{
                info.shareComponentType === '拼团' ? '拼团价:' : ''
              }}</span
              >¥</span
            >
            <span class="count"
              >{{ info.productPrice
              }}<template v-if="info.productPriceQi">起</template></span
            >
            <span class="origin" v-if="info && info.originalPrice"
              >¥{{ info.originalPrice / 100 }}</span
            >
            <span
              class="coupon-badge"
              v-if="
                info.shareComponentType && info.shareComponentType == '拼团'
              "
              >{{ info.shareComponentCount }}</span
            >
            <span class="coupon" v-if="info.couponInfo">{{
              info.couponInfo
            }}</span>
          </div>

          <div class="group-list" v-if="info.isGroupon">
            <!--少于等于5人，显示实际，没有这显示问号-->
            <div class="avater-list" v-if="info.groupCount <= 5">
              <div
                class="memember-avatar"
                v-for="(item, index) in info.groupMem"
                :key="'ma0_' + index"
              >
                <img
                  :src="groupOwner"
                  class="badge"
                  v-if="item && item.joinType === 1"
                />
                <img
                  class="avatar"
                  v-if="item"
                  :src="item.hecouponInfoadPic || defaultAvatar"
                  alt=""
                />
                <img v-else :src="unknownAvatar" />
              </div>
              <div
                class="memember-avatar"
                v-for="i in parseInt(info.shareComponentCount) -
                info.groupMem.length"
                :key="'ma1_' + i"
              >
                <img :src="unknownAvatar" />
              </div>
            </div>

            <!--大于5人分两种情况-->
            <div v-else>
              <!--实际拼图人数大于3 显示三个人的头像+省略号+问号-->
              <div class="avater-list" v-if="info.groupMem.length > 3">
                <div
                  class="memember-avatar"
                  v-for="(item, index) in info.groupMem.slice(0, 3)"
                  :key="'ma2_' + index"
                >
                  <img
                    :src="groupOwner"
                    class="badge"
                    v-if="item && item.joinType === 1"
                  />
                  <img
                    class="avatar"
                    v-if="item"
                    :src="item.hecouponInfoadPic || defaultAvatar"
                    alt=""
                  />
                </div>
                <div class="memember-avatar">
                  <img :src="ellipsisAvatar" />
                </div>
                <div class="memember-avatar">
                  <img :src="unknownAvatar" />
                </div>
              </div>

              <!--实际拼图人数小于3等于3的 显示实际人+问号-->
              <div class="avater-list" v-if="info.groupMem.length <= 3">
                <div
                  class="memember-avatar"
                  v-for="(item, index) in info.groupMem"
                  :key="'ma3_' + index"
                >
                  <img
                    :src="groupOwner"
                    class="badge"
                    v-if="item && item.joinType === 1"
                  />
                  <img
                    class="avatar"
                    v-if="item"
                    :src="item.hecouponInfoadPic || defaultAvatar"
                    alt=""
                  />
                </div>
                <div
                  class="memember-avatar"
                  v-for="i in 5 - info.groupMem.length"
                  :key="'ma4_' + i"
                >
                  <img :src="unknownAvatar" />
                </div>
              </div>
            </div>
            <div class="memember-tips">
              仅剩<span class="tips-count">{{ info.surPlus }}</span
              >个名额， {{ day }}天{{ hour }}:{{ minute }}:{{ second }}后结束
            </div>
          </div>
          <div class="qr-code">
            <canvas id="qrcode"></canvas>
            <img src="../../assets/images/Group 7@3x.png" />
          </div>
          <div class="qr-tips">{{ qrTips }}</div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import qrcode from 'qrcode'
import html2canvas from 'html2canvas'
import { isHZWAPP, isRKHYAPP, locationSearchToObject } from '@/utils'
import jsCookie from 'js-cookie'
import { queryShareKey } from '@/service/product'
import { delUrl } from '@/router/home/utils'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      unknownAvatar: require('../../assets/images/icon-unknow@3x.png'),
      // unknownAvatar:  require("../../assets/images/未登录@3x.png"),
      groupOwner: require('../../assets/images/lab-拼主@3x.png'),
      ellipsisAvatar: require('../../assets/images/icon-ellipsis@3x.png'),
      mockUrl:
        'http://hzwimspic-1251601690.image.myqcloud.com/37545960619968572227502326?imageView2/2/w/750/h/450/q/80/format/webp',
      qrTips: `— 长按或扫码，立即${
        this.info.shareComponentType === '拼团' ? '参团' : ''
      }购买 —`,
      ownerName: '',
      ownerAvatar: '../../assets/images/未登录@3x.png',
      defaultAvatar:
        '//cmspic-10004025.image.myqcloud.com/b6271cb0-cac7-11e9-b9f3-771201f995e5_size_135x135',
      day: '0',
      hour: '0',
      minute: '0',
      second: '0',
      isBase64HaveLoaded: false
    }
  },
  props: {
    // shareComponentType 秒杀 普通商详 拼团
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    shareRemark: {
      type: Object,
      default() {
        return {}
      }
    },
    isGroupDetail: {
      type: Boolean,
      default: false
    }
  },
  //监听属性 类似于data概念
  computed: {
    productTitleChars() {
      return this.info.productTitle.split('')
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    isInApp() {
      return true
      // return isRKHYAPP() || isHZWAPP()
    },
    // async getUserInfo() {
    //   const { nickname = "", photo = "" } = await this.$store.dispatch(
    //     "getUserInfoFromUser",
    //     {
    //       uid: this.$$cookie("uid"),
    //       skey: this.$$cookie("skey"),
    //     }
    //   );
    //   nickname && (this.ownerName = nickname);
    //   if (photo) {
    //     const image = new Image();
    //     image.src = photo.replace("http:", "");
    //     image.onload = () => {
    //       this.ownerAvatar = photo;
    //       this.initQrCode();
    //     };
    //   } else {
    //     this.ownerAvatar = require("../../assets/images/未登录@3x.png");
    //     this.initQrCode();
    //   }
    // },
    async getUserInfo() {
      if (this.$$cookie('uid') && this.$$cookie('skey')) {
        const { nickname = '', photo = '' } = await this.$store.dispatch(
          'getUserInfoFromUser',
          {
            uid: this.$$cookie('uid'),
            skey: this.$$cookie('skey')
          }
        )
        nickname && (this.ownerName = nickname)
        if (photo) {
          const image = new Image()
          image.src = photo.replace('http:', '')
          image.onload = () => {
            this.ownerAvatar = photo
            this.initQrCode()
          }
          return
        }
      }
      this.ownerAvatar = require('../../assets/images/未登录@3x.png')
      this.initQrCode()
    },
    calculateRemainingTime() {
      const endTime = this.info.targetTime
      const nowTime = Date.now() + this.info.timeOffset
      const left = (endTime - nowTime) / 1000
      let day = 0,
        hour = 0,
        minute = 0,
        second = 0
      if (left > 0) {
        day = Math.floor(left / (60 * 60 * 24))
        hour = Math.floor(left / (60 * 60)) - day * 24
        minute = Math.floor(left / 60) - day * 24 * 60 - hour * 60
        second =
          Math.floor(left) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        if (day <= 9) {
          day = `0${day}`
        }
        if (hour <= 9) {
          hour = `0${hour}`
        }
        if (minute <= 9) {
          minute = `0${minute}`
        }
        if (second <= 9) {
          second = `0${second}`
        }
        this.day = day
        this.hour = hour
        this.minute = minute
        this.second = second
      } else {
        this.day = 0
        this.hour = 0
        this.minute = 0
        this.second = 0
      }
    },
    loadCanvasBase64() {
      this.$nextTick(() => {
        const hre = encodeURIComponent(window.location.href)
        //  if(sessionStorage.getItem(hre)) {
        if (window[hre]) {
          this.sendShareMsg(window[hre])
        } else {
          const shareDom = document.querySelector('#canvas')
          html2canvas(shareDom, {
            useCORS: true,
            scale: 3,
            scrollX: 0,
            scrollY: 0
            // background: '#f5f5f5'
          }).then(canvas => {
            const data = canvas.toDataURL()
            // sessionStorage.setItem(hre,data)
            window[hre] = data
            this.sendShareMsg(data)
          })
        }
      })
    },
    sendShareMsg(base64Str) {
      let base64 = base64Str.split(',')[1]
      this.$emit('sendBase64', base64)
      this.$emit('loaded') // canvas绘制完成 人客中商详页触发 展示页面下方分享按钮
      this.isBase64HaveLoaded = true
    },
    /**
     * 原分享功能默认链接分享app本身会带上相关参数（如：hserecomkey）
     * 用来获取分享人相关信息
     * 本组件是生成图片分享，需要主动带上分享人相关信息
     */
    async getShareUserIdFromCookie() {
      let shareUserId
      // if(isRKHYAPP()){
      //   shareUserId = jsCookie.get('empId')
      // }else if(isHZWAPP()){
      //   // shareUserId = jsCookie.get('uid')
      //   let key =await queryShareKey()
      //   console.log('queryShareKey',key);
      //   if(key){
      //     shareUserId = key
      //   }
      // }
      shareUserId = await queryShareKey(this.shareRemark)
      return shareUserId
    },
    async initQrCode() {
      if (this.isGroupDetail) {
        const { uid } = await this.$$ensureLogin()
      }
      this.$nextTick(async () => {
        // 只有订单里的拼团详情分享出去的页面需要额外判断，其他地方url都可以直接是location.href
        let url = ''
        if (this.isGroupDetail) {
          this.groupId = this.$route.params.groupId
          const query = {
            inviteId: uid
          }
          const queryStr = this.$$queryString.stringify(query)
          url = `https:${this.$$hostname('life')}/v/order/group/${
            this.groupId
          }?${queryStr}&cmd=share&sharetype=0&refresh=no`
        } else {
          url = window.location.href
        }
        let shareUserId = await this.getShareUserIdFromCookie()
        if (shareUserId) {
          url += `${location.search ? '&' : '?'}hserecomkey=${shareUserId}`
        }
        // 如果链接里有shareEarn参数，分享时删除该参数
        url = delUrl(url, 'shareEarn')
        qrcode.toCanvas(
          document.getElementById('qrcode'),
          url,
          { errorCorrectionLevel: 'H' },
          error => {
            if (error) {
              console.log(error)
            } else {
              this.loadCanvasBase64()
            }
          }
        )
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  async created() {
    this.calculateRemainingTime()
    this.$$loading(false)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (this.isInApp()) {
      const image = new Image()
      image.src = this.$$viewImage(this.info.productImage).replace('http:', '')
      image.onload = () => {
        this.getUserInfo()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
@import '../../assets/css/mixin';
.mask {
  position: fixed;
  z-index: -9998;
  // height: 100%;
  // width: 100%;
  // height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // padding-bottom: 50px;
  // border:1px solid red;
  background: #f5f5f5;
}
#canvas {
  position: fixed;
  z-index: -9999;
  // height: 100%;
  // width: 100%;
  // height: 100%;
  top: 0;
  left: 0;
  right: 0;
  // border-radius: rem(16px);
  // bottom: 0;
  padding-bottom: rem(40px);
  // border:1px solid red;
  background: #f5f5f5;
}
.y-e-android {
  #canvas {
    padding-bottom: rem(100px);
  }
}
.share-conatiner {
  padding-top: rem(32px);
  .content {
    padding: rem(2px) rem(30px) rem(48px) rem(30px);
    background: #feffff;
    box-shadow: 0 rem(2px) rem(20px) 0 rgba(0, 0, 0, 0.04);
    border-radius: rem(24px);
    // border-radius: rem(16px);
    // border: 1px solid red;
    width: 92%;
    margin: 0 auto;
    // margin-top: rem(60px);
    .title {
      padding-top: rem(40px);
      padding-left: rem(5px);
      height: rem(160px);
      overflow: hidden;
      border-bottom: rem(1px) solid #eee;
      .avatar {
        width: rem(90px);
        height: rem(90px);
        float: left;
        border-radius: rem(100px);
      }
      .tips {
        position: relative;
        top: rem(5px);
        margin-left: rem(106px);
        .top {
          font-size: rem(30px);
          color: #121212;
          line-height: rem(40px);
          .name {
            // font-size: rem(32px);
            font-weight: 700;
          }
        }
        .bottom {
          margin-top: rem(8px);
          font-size: rem(24px);
          color: #666666;
          line-height: rem(30px);
        }
      }
    }
    .item-img {
      margin-top: rem(30px);
      width: rem(630px);
      height: rem(340px);
      border-radius: 10px;
    }
    .product-title {
      font-weight: 700;
      font-size: rem(28px);
      color: #121212;
      letter-spacing: 0;
      line-height: rem(36px);
      margin-top: rem(32px);
      overflow: hidden;
      // white-space: nowrap;
      text-overflow: ellipsis;
      width: rem(630px);
      display: flex;

      flex-wrap: wrap;
      max-height: rem(72px);
      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .coupon {
        padding: rem(0px) rem(12px) rem(6px) rem(12px);
        background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
        border-radius: rem(18px);
        border-radius: rem(18px);
        height: rem(36px);
        font-size: rem(18px);
        color: #ffffff;
        letter-spacing: 0;
        position: relative;
        line-height: rem(36px);
        font-weight: 400;
      }
    }
    .product-price {
      height: rem(30px);
      line-height: rem(30px);
      margin-top: rem(5px);
      font-weight: 700;
      .icon {
        font-size: rem(22px);
        color: #ff397e;
        letter-spacing: 0;
        line-height: rem(30px);
        .price-tips {
          font-size: rem(28px);
          font-weight: normal;
          margin-right: rem(5px);
        }
      }
      .count {
        font-size: rem(34px);
        color: #ff397e;
        letter-spacing: 0;
        line-height: rem(36px);
        position: relative;
        left: rem(-2px);
      }
      .origin {
        text-decoration: line-through;
        font-size: rem(26px);
        font-weight: normal;
        color: #666666;
        letter-spacing: 0;
        line-height: rem(28px);
        // position: relative;
        // top:rem(-10px);
      }
      .coupon {
        font-weight: normal;
        padding: rem(4px) rem(12px);
        background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
        border-radius: rem(18px);
        border-radius: rem(18px);
        height: rem(24px);
        font-size: rem(22px);
        color: #ffffff;
        letter-spacing: 0;
        line-height: rem(24px);
        position: relative;
        top: rem(-5px);
      }
      .coupon-badge {
        position: relative;
        top: rem(-6px);
        padding-top: rem(2.5px);
        padding-bottom: rem(2.5px);
        padding-left: rem(12px);
        padding-right: rem(12px);
        font-size: rem(22px);
        background: #fff5f8;
        border: rem(1.5px) solid #ff397e;
        border-radius: 17px;
        border-radius: 17px;
        font-weight: normal;
        color: #ff397e;
      }
    }
    .group-list {
      margin-top: rem(60px);
      .avater-list {
        display: flex;
        justify-content: center;

        .memember-avatar:first-child {
          border: rem(4px) solid #ff397e;
          width: rem(100px);
          background: #f5f5f5;
          height: rem(100px);
          // img {
          //     position: relative;
          //     top: rem(2px);
          // }
          .avatar {
            width: rem(90px);
            height: rem(90px);
            border-radius: rem(100px);
            position: relative;
            // top: rem(px);
            left: rem(0px);
          }
        }
        .memember-avatar {
          position: relative;
          display: inline-block;
          // background: #D8D8D8;
          // border: 3x solid #fff;
          margin-right: rem(10px);
          width: rem(108px);
          height: rem(108px);
          border-radius: 100px;
          // img {
          //   position: relative;
          //   top: rem(5px);
          // }
          .badge {
            // width: rem(55px);
            position: absolute;
            z-index: 10;
            height: rem(34px);
            top: rem(-16px);
            // right: rem(px);
            // line-height: rem(32px);
            font-size: rem(20px);
            color: #feffff;
            letter-spacing: 0;
            // line-height: rem(32px);
            // background: #FF397E;
            // border: 1px solid #FFFFFF;

            left: rem(-6px);
            // text-align: center;
            .text {
              // padding: rem(3px) rem(8px) ;
              padding-left: rem(8px);
              padding-right: rem(8px);
              // padding-top:rem(8px);
              display: inline-block;
              // transform: scale(.83333);
              font-size: rem(20px);
            }
          }
          .avatar {
            width: rem(100px);
            height: rem(100px);
            border-radius: rem(100px);
            position: relative;
            top: rem(0px);
            left: rem(0px);
          }
        }
      }

      .memember-tips {
        margin: rem(19.7px) auto;
        font-size: rem(30px);
        color: #000000;
        letter-spacing: 0;
        line-height: rem(87px);
        height: rem(87px);
        border-radius: rem(16px);
        // width: rem(630px);
        padding-left: rem(30px);
        background: #f5f5f5;
        // padding-right: rem(30px);
        .tips-count {
          color: #ff397e;
        }
      }
      .count-down {
        // font-size: rem(30px);
        // vertical-align:middle;
      }
    }
    .qr-code {
      width: 2.4rem !important;
      height: 2.4rem !important;
      margin: 0 auto;
      margin-top: rem(50px);
      position: relative;
      #qrcode {
        width: 2.4rem !important;
        height: 2.4rem !important;
      }
      img {
        width: rem(62px);
        height: rem(62px);
        position: absolute;
        top: 0.92rem;
        left: 0.92rem;
      }
    }
    .qr-tips {
      font-size: rem(26px);
      // width: 330px;
      // height: 32px;
      margin-top: rem(8px);
      text-align: center;
      color: #808080;
      letter-spacing: 0;
    }
  }
  .picc {
    margin-top: rem(20px);
    font-size: rem(22px);
    margin-left: rem(30px);
    color: #bfbfbf;
    letter-spacing: 0;
    line-height: rem(28px);
  }
}
</style>
